export default __webpack_public_path__ + "static/media/icon-pinterest.a2d25ab4.svg";